import * as React from 'react'
import xss, { IWhiteList } from 'xss'

interface Props {
  htmlContent: string
  allowList?: IWhiteList
  onTag?: XSS.OnTagHandler
  WrapperComponent?: React.FC<React.PropsWithChildren<{ dangerouslySetInnerHTML?: { __html: string | TrustedHTML } }>>
}

const DefaultWrapperComponent = ({
  dangerouslySetInnerHTML,
}: React.PropsWithChildren<{ dangerouslySetInnerHTML?: { __html: string | TrustedHTML } }>) => (
  <div dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
)
export const FormattedContent = ({
  htmlContent,
  allowList,
  onTag,
  WrapperComponent = DefaultWrapperComponent,
}: React.PropsWithChildren<Props>) => {
  const whiteList = allowList ? allowList : undefined
  const __html = xss(htmlContent, { whiteList, onTag })
  return <WrapperComponent dangerouslySetInnerHTML={{ __html }} />
}
